import React from 'react';
import { useTranslation } from 'react-i18next';
import { House } from '../types';
import { HouseCard } from './house-card';

interface HousesGridProps {
  houses: House[];
  isComingSoon?: boolean;
  isLoading?: boolean;
}

export const HousesGrid: React.FC<HousesGridProps> = ({
  houses,
  isComingSoon = false,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-N900"></div>
      </div>
    );
  }

  if (!houses || houses.length === 0) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <p className="text-lead1 font-normal text-N700">{t('js.features.marketplace.home.find_your_next_home_section.no_houses_available')}</p>
      </div>
    );
  }

  return (
    <>
      {/* Desktop Grid: 3 columns */}
      <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {houses.map((house) => (
          <HouseCard key={house.id} house={house} isComingSoon={isComingSoon} />
        ))}
      </div>

      {/* Mobile Horizontal Scroll */}
      <div className="md:hidden overflow-x-auto -mx-4 px-4 scrollbar-hide">
        <div className="flex gap-4 pb-4">
          {houses.map((house) => (
            <div key={house.id} className="flex-shrink-0 w-[280px]">
              <HouseCard house={house} isComingSoon={isComingSoon} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
